import type { ProfileData } from "./ProfileData"

export enum SessionStatusType {
  ANONYMOUS = 'ANONYMOUS',
  LOGGEDIN = 'LOGGEDIN',
  SOFTLOGGEDIN = 'SOFTLOGGEDIN'
}

export type User = {
  profileData?: ProfileData,
  sessionStatus: SessionStatusType,
  loyaltyId?: string,
  segments?: {
    hasKcc?: boolean
  }
}

export type UserName = {
  first: string
  last: string
}

export class ProfileCookie {
  id: string
  expires: string

  constructor(id: string, expires: string) {
    this.id = id
    this.expires = expires
  }
}

export class SessionCookie {
  id: string
  expires: string

  constructor(id: string, expires: string) {
    this.id = id
    this.expires = expires
  }
}

export class AuthenticatedUser {
  profile: ProfileCookie
  session: SessionCookie

  constructor(session: SessionCookie, profile: ProfileCookie) {
    this.session = session
    this.profile = profile
  }
}

export const isAuthenticatedUser = (updatePWSuccess: string | {}): updatePWSuccess is AuthenticatedUser => {
  return typeof updatePWSuccess === 'string' ? false : Object.hasOwn(updatePWSuccess, 'session')
}
